import React, { useState } from "react";
import * as Icons from "lucide-react";
import RegistryPage from "../components/RegistryPage";
import { RiskBadge, StatusBadge } from "../components/Badges";
import TasksKanban from "./Tasks";

function GapsTable() {
  return (
    <RegistryPage
      title=""
      description=""
      endpoint="/gaps"
      testIdPrefix="gaps"
      reportKey="gaps"
      columns={[
        { key: "section", label: "Section", width: "140px" },
        { key: "title", label: "Title" },
        { key: "risk", label: "Risk", width: "90px", render: (i) => <RiskBadge level={i.risk} /> },
        { key: "responsible_role", label: "Owner Role", width: "120px" },
        { key: "status", label: "Status", width: "110px", render: (i) => <StatusBadge status={i.status} /> },
        { key: "due_date", label: "Due", width: "110px", render: (i) => (i.due_date || "").slice(0,10) },
      ]}
      fields={[
        { key: "section", label: "Section", required: true },
        { key: "title", label: "Title", required: true, full: true },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "risk", label: "Risk", type: "select", options: ["low","medium","high","critical"] },
        { key: "responsible_role", label: "Responsible Role", type: "select", options: ["dpo","legal_reviewer","security_officer","business_owner","vendor_manager","org_admin"] },
        { key: "recommended_action", label: "Recommended Action", type: "textarea", full: true },
        { key: "evidence_required", label: "Evidence Required", type: "textarea", full: true },
        { key: "legal_reference", label: "Legal Reference" },
        { key: "status", label: "Status", type: "select", options: ["open","in_progress","closed"] },
        { key: "due_date", label: "Due Date (ISO)" },
      ]}
      defaultItem={{ section: "", title: "", description: "", risk: "medium", responsible_role: "dpo", status: "open", recommended_action: "", evidence_required: "", legal_reference: "DPDP Act, 2023" }}
    />
  );
}

export default function GapRegister() {
  const [tab, setTab] = useState("gaps");
  return (
    <div data-testid="gaps-tasks-page">
      <div className="mb-1">
        <h1 className="text-xl font-bold ink">Gap Register & Tasks</h1>
        <p className="text-[12px] muted">DPDP gaps auto-generated from assessments plus the remediation task board — one workspace.</p>
      </div>
      <div className="my-4 flex items-center gap-1 surface rounded-lg p-1 w-fit" style={{ border: "1px solid var(--border)" }}>
        {[{ k: "gaps", l: "Gap register", i: "AlertTriangle" }, { k: "tasks", l: "Tasks board", i: "ListTodo" }].map(t => {
          const I = Icons[t.i];
          return (
            <button key={t.k} data-testid={`gaps-tab-${t.k}`} onClick={() => setTab(t.k)}
              className="px-3 py-1.5 text-xs font-medium rounded-md transition-all flex items-center gap-1.5"
              style={{ background: tab === t.k ? "var(--primary-soft)" : "transparent", color: tab === t.k ? "var(--primary)" : "var(--muted)" }}>
              <I className="w-3.5 h-3.5" /> {t.l}
            </button>
          );
        })}
      </div>
      {tab === "gaps" ? <GapsTable /> : <TasksKanban embedded />}
    </div>
  );
}
